import { HeaderAssociationUI } from './HeaderAssociationUI'
import { useHeader } from './useHeader'

export const HeaderAssociationComponent = () => {
  const props = useHeader()

  return <HeaderAssociationUI {...props} />
}
